import React, { Component } from 'react';
import { FormattedMessage } from 'translations';
import { FormattedMessage as MZFormattedMessage } from 'mz-intl';
import { Layout, Flex } from 'app/components/base/Layout';
import LoadingSpinner from 'app/components/base/LoadingSpinner';
import Button from 'app/components/base/Button';
import { Field } from 'redux-form';
import FormInput from 'app/components/base/FormInput';
import { SELECTED_TRIP_FIELD_NAME } from '../builder';
import classnames from 'classnames';
import mzMessages from '../../../../messages.intl'


import style from './style.css';

const messages = {
  updateTrip: { id: 'BOOK_TRIP.MEET_AND_GREET.UPDATE_TRIP_BUTTON' },
  calcel: { id: 'CANCEL' },
  errorMessage: { id: 'SEARCH_RESULTS.ERROR_MESSAGE' }
};

/**
 * Component for selecting departure and return schedules
 */
class TripsWithMeetAndGreetDialog extends Component {

  constructor(props) {
    super(props);

    // triggers suggestions loading
    this.props.onInit()
      .then(() => this.setState({ loading: false, error: false }))
      .catch(() => this.setState({ loading: false, error: true }));
  }

  state = {
    loading: true,
    error: false
  }

  handleSelect = () => {
    const { selectedTrip, onConfirm } = this.props;

    onConfirm(selectedTrip);
  }

  renderContent = () => {
    const {
      trips,
      tripComponent,
      mobile,
    } = this.props;
    const hasResults = !this.state.loading && !this.state.error && trips && trips.length

    return (
      <Layout className={classnames(style.content, { [style.mobile]: mobile })}>
        {this.state.loading && (
          <Flex className={style.loading} size="nogrow">
            <LoadingSpinner size="large" />
          </Flex>
        )}
        {hasResults && (
          trips.map((trip, index) => (
            <Field
              className={style.field}
              key={index}
              name={SELECTED_TRIP_FIELD_NAME}
              component={FormInput}
              type="radio"
              value={`${trip.id}`}
              clean
              stretch
            >
              {React.createElement(tripComponent, {
                className: style.trip,
                ...trip,
                isBookable: false
              })}
            </Field>
          ))
        )}
        {!hasResults && (
          <div className={style.errorMessage}>
            <MZFormattedMessage message={mzMessages.NO_MEET_AND_GREET_RESULTS}/>
          </div>
        )}
        {this.state.error && (
          <div className={style.errorMessage}>
            <span><FormattedMessage {...messages.errorMessage} /></span>
          </div>
        )}
      </Layout>
    );
  };

  render() {
    const {
      selectedTrip,
      onClose,
      mobile
    } = this.props;

    return (
      <Layout
        className={classnames(style.container, { [style.mobile]: mobile })}
        direction="column"
        align="start stretch"
        size="noshrink"
        nowrap
      >
        {
          this.renderContent()
        }
        <Layout
          className={style.buttons}
          direction="row"
          align="end center"
        >
          <Button
            className={style.buttonCancel}
            nocaps
            rounded
            large
            transparent
            onClick={onClose}
            disabled={this.state.loading}
          >
            <FormattedMessage {...messages.calcel} />
          </Button>

          <Button
            className={style.buttonSelect}
            nocaps
            rounded
            large
            onClick={this.handleSelect}
            disabled={this.state.loading || this.state.error || !selectedTrip}
          >
            <FormattedMessage {...messages.updateTrip} />
          </Button>
        </Layout>
      </Layout>
    );
  }
}

// TODO: move to Flow types
// TripsWithMeetAndGreetDialog.propTypes = {
//   mobile: PropTypes.bool,
//   trips: PropTypes.array,
//   tripComponent: PropTypes.oneOfType([
//     PropTypes.string,
//     PropTypes.func
//   ]),
//   selectedTrip: PropTypes.string,
//   onInit: PropTypes.func,
//   onClose: PropTypes.func,
//   onConfirm: PropTypes.func.isRequired,
// };


export default TripsWithMeetAndGreetDialog;
